import Vue from 'vue';
import VueGtag from 'vue-gtag';
import { VueHammer } from 'vue2-hammer';
import VueLogger from 'vuejs-logger';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

require('jspolyfill-array.prototype.find');

const isProduction = process.env.NODE_ENV === 'production';

const options = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true,
};

Vue.use(VueLogger, options);

Vue.use(VueHammer);

Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GA,
    params: {
      send_page_view: false,
    },
  },
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

// App["$log"] = Vue.$log;
store['$log'] = Vue.$log;
